import { render, staticRenderFns } from "./ReservationTeacher.vue?vue&type=template&id=05b47ea3&"
import script from "./ReservationTeacher.vue?vue&type=script&lang=js&"
export * from "./ReservationTeacher.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports